export default class ClientDto
{
    public id: number|null = null;
    public name = '';
    public comments: string|null = null;
    public url: string|null = null;
    public email: string|null = null;
    public addressLine1: string|null = null;
    public addressLine2: string|null = null;
    public addressTown: string|null = null;
    public addressCounty: string|null = null;
    public addressPostcode: string|null = null;
    public archived = false;
    public disabled = false;
    public dateCreated = '';
}